<template>
  <div>
    <header class="a-service-header type_mypack">
      <div class="header-inner">
        <h1 class="sp_a-service sp_header-logo"><a href="/" class="link-home router-link-active">my pack</a></h1>
      </div>
    </header>
    <!-- S : 2020 login renewal -->
    <div class="login-iframe login-renewal">
      <div class="login-area">
        <form @submit.prevent="handleSubmit">
          <div class="box_login-from">
            <h1 class="login-title">로그인</h1>
            <div class="login-desc"><a target="_blank" href="https://www.amway.co.kr">Amway 사이트</a>와 동일한 ID/PW로 로그인 해주세요.</div>
            <div class="line_form-type">
              <input type="text" v-model="form.j_username" placeholder="아이디/회원번호" class="form_lines" title="아이디/회원번호">
              <p class="text_validation" id="loginInput" style="display:none;">아이디를 입력하세요</p>
              <div class="form_group-button form_group-button-login">
                <button type="button" class="form_element-button-delete" tabindex="-1" style="display: none;">
                  <span class="btn_del">삭제</span>
                </button>
              </div>
            </div>
            <div class="line_form-type">
              <input type="password" v-model="form.j_password" placeholder="비밀번호" class="form_lines" title="비밀번호 입력" maxlength="30">
              <p class="text_validation" id="pwInput" style="display:none;">비밀번호를 입력하세요</p>
              <div class="form_group-button form_group-button-login">
                <button type="button" class="form_element-button-delete" tabindex="-1" style="display: none;">
                  <span class="btn_del">삭제</span>
                </button>
                <button type="button" class="form_element-button-eye" style="display: none;">
                  <span class="btn_eye btn_eye_on">보기</span>
                </button>
              </div>
            </div>
            <div class="login_btn-group">
              <button type="submit" class="btn_login-normal" id="Login_Login">로그인</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- E : 2020 login renewal -->
    <modal-alert ref="refAlert" />
  </div>
</template>
<script>
//import axios from "axios";
import http from '@/utils/http';
import ModalAlert from '@/components/global/ModalAlert';

export default {
  name: 'Login',
  components: {
    ModalAlert,
  },
  data() {
    return {
      form: {
        bSid: this.$route.query.bSId,
        j_username: "",
        j_password: "",
        remember: "",
        autologin: ""
      }
    };
  },
  watch: {
    "$route.query.bSid"(newId) {
      this.bSid = newId;
    },
    j_username(newname) {
      if(newname) {

      }
    }
  },
  methods: {
    async handleSubmit() {
      try {
        //const response = await axios.post("/api/login", this.form);
        const result = await http.post(`/login`, this.form);
        console.log("서버 응답:", result.state);
        switch(result.state) {
          case "FAIL": {
            await this.$refs.refAlert.openWithMessage('아이디/회원번호나 비밀번호가 잘못되었습니다.');
            break;
          }
          case "SUCCESS": {
            const url = result.cause.data.redirectUrl;
            if(url) {
              location.href = url;
              return;
            }
            // https://fknd12.tistory.com/171
            const os = (window.navigator.userAgent || window.navigator.vgjendor || window.opera).toLocaleLowerCase();
            if(os.indexOf("android") > -1) {
              location.href = "kakaotalk://inappbrowser/close";
            }
            else if(os.indexOf("iphone") > -1 || os.indexOf("ipad") > -1) {
              location.href = "kakaoweb://closeBrowser";
            }
            else {
              self.close();
            }
            break;
          }
          case "ERROR": {
            console.log(result.cause);
            await this.$refs.refAlert.openWithMessage(`에러가 발생하였습니다.\n${result.cause}`);
            break;
          }
          default: {
            console.log(result.state);
            await this.$refs.refAlert.openWithMessage(`에러가 발생하였습니다.\n${result.state}`);
            break;
          }
        }
      }
      catch (e) {
        console.error("에러 발생:", e);
        await this.$refs.refAlert.openWithMessage(`에러가 발생하였습니다.\n${e}`);
      }
    }
  }
};
</script>
<style>
.login-area {max-width: 325px;width: 100%;margin: 0 auto;}
.login-area .login-title {margin: 0 0 2px;font-size: 24px;font-weight: 700;color: #002f5f;letter-spacing: -1px;line-height: 36px;}
.login-area .login-desc {margin: 0 0 38px;}
.line_form-type .form_lines {height: 30px;border-width: 0 0 1px 0;border-color: #dedede;width: 100%;padding: 0;font-size: 14px;color: #333;    letter-spacing: -.5px;outline: none;}
.line_form-type .form_lines::placeholder{color: #999;letter-spacing: -0.5px;}
.line_form-type .text_validation {margin: 9px 0 0 0;font-size: 12px;color: #ed2250;letter-spacing: -.5px;}
.line_form-type ~ .line_form-type {margin-top: 12px;}
.login_btn-group {margin-top: 15px;}
.login_btn-group [class^="btn_login-"] {width: 100%;height: 54px;border-radius: 4px;text-align: center;border: none;letter-spacing: -.5px;}
.login_btn-group .btn_login-normal {background-color: #00305e;color: #fff;font-size: 16px;font-weight: 700;}
.login_btn-group [class^="btn_login-"] ~ [class^="btn_login-"] {margin-top: 10px;}
.box_login-etc {margin-top: 17px;text-align: center;font-size: 0;}
.box_login-etc .login_etc-item {display: inline-block;vertical-align: top;padding: 0 20px;}
.box_login-etc .login_etc-item ~ .login_etc-item { position: relative;}
.box_login-etc .login_etc-item ~ .login_etc-item:before {content: '';position: absolute;left: 0;top: 50%;width: 1px;height: 16px;margin-top: -8px;background-color: #e6e6e6;}
/* S mobile */
@media (max-width: 768px) {
    .login-area .login-title {display: none;}
}
/* E mobile */
</style>



// WEBPACK FOOTER //
// src/views/home/main/Login.vue